document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-predictive-search]').forEach(function (root) {
    var input = root.querySelector('[data-predictive-search-input]');
    var target = root.querySelector('[data-predictive-search-target]');
    if (!input || !target) return;
    var timer;
    var controller;

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (!term) {
        target.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
        return;
      }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url =
          window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'search/suggest'
            : '/search/suggest';
        fetch(
          url +
            '.json?q=' +
            encodeURIComponent(term) +
            '&resources[type]=product,collection,page,article&resources[limit]=6&section_id=predictive-search',
          {signal: controller.signal},
        )
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            var html = (data.sections && data.sections['predictive-search']) || '';
            target.innerHTML = html;
            input.setAttribute('aria-expanded', html ? 'true' : 'false');
          })
          .catch(function () {});
      }, 250);
    });
  });
});
